<template>
    <div>
    <div class="ck-dayin">
        <div class="title">
            <div class="title-left">
                <p>{{tableData.FAccName === '艾巢'?'广州艾巢' : tableData.FAccName}}用车-物流申请单</p>
                <p>发货通知单</p>
            </div>
                <div class="title-right">
                <img :src="'http://api.k780.com/?app=barcode.get&bc_text='+tableData.order_number+'&appkey=10003&sign=b59bc3ef6191eb9f747dd4e83c99f2a4&bc_fontsize=10&bc_resolution=2'">
            </div>
        </div>
        <div class="center">
            <div class="center-left">
                <span>出货仓库</span><span class="fs25" style="display: inline-block;width: 70%;text-align: center">{{tableData.warehouse}}</span>
            </div>
            <div class="center-right">
                <div>
                    <span>合同订单号　{{tableData.contract_number}}</span>
                    <span style="float: right">申请日期: {{tableData.addtime|formatter}}</span>
                </div>
                <div style="padding-top: 10px">
                    <span>　　客户:　{{tableData.customer}}</span>
                </div>
            </div>
            <div style="margin-top: 8px;padding-left: 15px">
                <span>备注: {{tableData.note}}</span>
            </div>
        </div>
        <div class="table">
            <table style="width: 100%;">
                <tr>
                    <td>通知单号</td>
                    <td style="width: 8%">{{tableData.order_number}}</td>
                    <td style="width: 10%">部门</td>
                    <td colspan="3">{{tableData.department}}</td>
                    <td>物流公司</td>
                    <td class="fs25">{{tableData.logistics_company}}</td>
                    <td>货运方式</td>
                    <td class="fs25" colspan="2" style="width: 10%">{{tableData.transport_way}}<span style="opacity: 0" v-if="tableData.transport_way===''">aaaaa</span></td>
                </tr>
                <tr>
                    <td style="width: 10%">收货人</td>
                    <td>{{tableData.FShr}}</td>
                    <td>联系电话</td>
                    <td colspan="3" style="width: 15%;max-width: 15%">{{tableData.phone}}</td>
                    <td style="width: 8%">到达时间</td>
                    <td style="width: 18%">{{tableData.arrival_time}}</td>
                    <td style="width: 8%">收款方式</td>
                    <td style="width: 8%">{{tableData.pay_way}}</td>
                </tr>
                <tr>
                    <td>收货地址</td>
                    <td colspan="4"  style="width: 40%">{{tableData.address}}</td>
                    <td style="width: 10%">收款金额</td>
                    <td>　</td>
                    <td>物流收费方式</td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="2">产品名称</td>
                    <td colspan="4">规格型号</td>
                    <td colspan="2">单位</td>
                    <td colspan="2">数量</td>
                </tr>
                <tr v-for="(item, index) in goodsList">
                    <td colspan="2">{{item.goods_name}}</td>
                    <td colspan="4" class="fs18">{{item.model}}</td>
                    <td colspan="2">{{item.unit}}</td>
                    <td colspan="2">{{item.goods_num}}</td>
                </tr>
                <tr v-for="(item, index) in ShengLength">
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                    <td colspan="4" class="fs18"><span style="opacity: 0">-</span></td>
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                </tr>
                <tr>
                    <td colspan="8">合计</td>
                    <td colspan="2">{{allNum1}}</td>
                </tr>
            </table>
            <div class="btn">
                <span style="display: inline-block;width: 24%">{{tableData.FAccName|Company}}</span>
                <span style="display: inline-block;width:30%">联系电话:{{tableData.FAccName|Mobile}}</span>
                <span style="display: inline-block;width:24%">受理人: </span>
                <span style="display: inline-block;width:16%">申请人: {{tableData.made_person}}</span>
            </div>
        </div>
    </div>
    <div class="ck-dayin" v-show="isShow" >
        <div class="title">
            <div class="title-left">
                <p>{{tableData.FAccName}}用车-物流申请单</p>
                <p>发货通知单</p>
            </div>
            <div class="title-right">
                <img :src="'http://api.k780.com/?app=barcode.get&bc_text='+tableData.order_number+'&appkey=10003&sign=b59bc3ef6191eb9f747dd4e83c99f2a4&bc_fontsize=10&bc_resolution=2'">
            </div>
        </div>
        <div class="center">
            <div class="center-left">
                <span>出货仓库</span><span class="fs25" style="display: inline-block;width: 70%;text-align: center">{{tableData.warehouse}}</span>
            </div>
            <div class="center-right">
                <div>
                    <span>合同订单号　{{tableData.contract_number}}</span>
                    <span style="float: right">申请日期: {{tableData.addtime|formatter}}</span>
                </div>
                <div style="padding-top: 10px">
                    <span>　　客户:　{{tableData.customer}}</span>
                </div>
            </div>
            <div style="margin-top: 8px;padding-left: 15px">
                <span>备注: {{tableData.note}}</span>
            </div>
        </div>
        <div class="table">
            <table style="width: 100%;">
                <tr>
                    <td>通知单号</td>
                    <td>{{tableData.order_number}}</td>
                    <td>部门</td>
                    <td colspan="3">{{tableData.department}}</td>
                    <td>物流公司</td>
                    <td class="fs25">{{tableData.logistics_company}}</td>
                    <td>货运方式</td>
                    <td class="fs25" colspan="2" style="width: 10%">{{tableData.transport_way}}<span style="opacity: 0" v-if="tableData.transport_way===''">aaaaa</span></td>
                </tr>
                <tr>
                    <td>收货人</td>
                    <td>{{tableData.FShr}}</td>
                    <td>联系电话</td>
                    <td colspan="3" style="max-width: 20%">{{tableData.phone}}</td>
                    <td>到达时间</td>
                    <td style="width: 20%">{{tableData.arrival_time}}</td>
                    <td>收款方式</td>
                    <td>{{tableData.pay_way}}</td>
                </tr>
                <tr>
                    <td>收货地址</td>
                    <td colspan="4">{{tableData.address}}</td>
                    <td>收款金额</td>
                    <td>　</td>
                    <td>物流收费方式</td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="2">产品名称</td>
                    <td colspan="4">规格型号</td>
                    <td colspan="2">单位</td>
                    <td colspan="2">数量</td>
                </tr>
                <tr v-for="(item, index) in goodsList1">
                    <td colspan="2">{{item.goods_name}}</td>
                    <td colspan="4" class="fs18">{{item.model}}</td>
                    <td colspan="2">{{item.unit}}</td>
                    <td colspan="2">{{item.goods_num}}</td>
                </tr>
                <tr v-for="(item, index) in ShengLength">
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                    <td colspan="4" class="fs18"><span style="opacity: 0">-</span></td>
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                    <td colspan="2"><span style="opacity: 0">-</span></td>
                </tr>
                <tr>
                    <td colspan="8">合计</td>
                    <td colspan="2">{{allNum2}}</td>
                </tr>
            </table>
            <div class="btn">
                <span style="display: inline-block;width: 24%">{{tableData.FAccName|Company}}</span>
                <span style="display: inline-block;width:30%">联系电话:{{tableData.FAccName|Mobile}}</span>
                <span style="display: inline-block;width:24%">受理人: </span>
                <span style="display: inline-block;width:16%">申请人: {{tableData.made_person}}</span>
            </div>
        </div>
    </div>
        <div class="ck-dayin" v-show="isShow2" >
            <div class="title">
                <div class="title-left">
                    <p>{{tableData.FAccName}}用车-物流申请单</p>
                    <p>发货通知单</p>
                </div>
                <div class="title-right">
                    <img :src="'http://api.k780.com/?app=barcode.get&bc_text='+tableData.order_number+'&appkey=10003&sign=b59bc3ef6191eb9f747dd4e83c99f2a4&bc_fontsize=10&bc_resolution=2'">
                </div>
            </div>
            <div class="center">
                <div class="center-left">
                    <span>出货仓库</span><span class="fs25" style="display: inline-block;width: 70%;text-align: center">{{tableData.warehouse}}</span>
                </div>
                <div class="center-right">
                    <div>
                        <span>合同订单号　{{tableData.contract_number}}</span>
                        <span style="float: right">申请日期: {{tableData.addtime|formatter}}</span>
                    </div>
                    <div style="padding-top: 10px">
                        <span>　　客户:　{{tableData.customer}}</span>
                    </div>
                </div>
                <div style="margin-top: 8px;padding-left: 15px">
                    <span>备注: {{tableData.note}}</span>
                </div>
            </div>
            <div class="table">
                <table style="width: 100%;">
                    <tr>
                        <td>通知单号</td>
                        <td>{{tableData.order_number}}</td>
                        <td>部门</td>
                        <td colspan="3">{{tableData.department}}</td>
                        <td>物流公司</td>
                        <td class="fs25">{{tableData.logistics_company}}</td>
                        <td>货运方式</td>
                        <td class="fs25" colspan="2" style="width: 10%">{{tableData.transport_way}}<span style="opacity: 0" v-if="tableData.transport_way===''">aaaaa</span></td>
                    </tr>
                    <tr>
                        <td>收货人</td>
                        <td>{{tableData.FShr}}</td>
                        <td>联系电话</td>
                        <td colspan="3" style="max-width: 20%">{{tableData.phone}}</td>
                        <td>到达时间</td>
                        <td style="width: 20%">{{tableData.arrival_time}}</td>
                        <td>收款方式</td>
                        <td>{{tableData.pay_way}}</td>
                    </tr>
                    <tr>
                        <td>收货地址</td>
                        <td colspan="4">{{tableData.address}}</td>
                        <td>收款金额</td>
                        <td>　</td>
                        <td>物流收费方式</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="2">产品名称</td>
                        <td colspan="4">规格型号</td>
                        <td colspan="2">单位</td>
                        <td colspan="2">数量</td>
                    </tr>
                    <tr v-for="(item, index) in goodsList2">
                        <td colspan="2">{{item.goods_name}}</td>
                        <td colspan="4" class="fs18">{{item.model}}</td>
                        <td colspan="2">{{item.unit}}</td>
                        <td colspan="2">{{item.goods_num}}</td>
                    </tr>
                    <tr v-for="(item, index) in ShengLength">
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                        <td colspan="4" class="fs18"><span style="opacity: 0">-</span></td>
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                        <td colspan="2"><span style="opacity: 0">-</span></td>
                    </tr>
                    <tr>
                        <td colspan="8">合计</td>
                        <td colspan="2">{{allNum3}}</td>
                    </tr>
                </table>
                <div class="btn">
                    <span style="display: inline-block;width: 24%">{{tableData.FAccName|Company}}</span>
                    <span style="display: inline-block;width:30%">联系电话:{{tableData.FAccName|Mobile}}</span>
                    <span style="display: inline-block;width:24%">受理人: </span>
                    <span style="display: inline-block;width:16%">申请人: {{tableData.made_person}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tableData: JSON.parse(localStorage.getItem('CangkuDayin')),
                ShengLength: '',
                allNum1: 0,
                allNum2: 0,
                allNum3: 0,
                isShow: false,
                isShow2: false,
                goodsList: [],
                goodsList1: [],
            }
        },
        filters: {
            formatter(time) {
                return new Date(time * 1000).toLocaleDateString().toString().replace(/\//g, '-')
            },
            Company(name) {
              if (name === '广州亿星') {
                  return '广州亿星人居环境设备有限公司'
              } else if (name === '艾巢') {
                  return '广州艾巢环境科技有限公司'
              } else if (name === '森林春天') {
                  return '广州森林春天机电设备有限公司'
              } else if (name === '广州集源') {
                  return '广州集源供应链有限公司'
              } else if (name === '满园生活') {
                  return '广州满园生活环境科技有限公司'
              } else if (name === '广东诺诚') {
                  return '广东诺诚机电设备安装有限公司'
              }
            },
            Mobile (name) {
                if (name === '广州亿星') {
                    return '36400123　　86187083'
                } else if (name === '艾巢') {
                    return '36400123　　86180196'
                } else if (name === '森林春天') {
                    return '36400123　　36882718'
                } else if (name === '广州集源') {
                    return '36400123　　86181120'
                } else if (name === '满园生活') {
                    return '36400123　　86187288'
                } else if (name === '广东诺诚') {
                    return '36400123　　86187020'
                }
            }
        },
        created() {
            // console.log(this.tableData);
            if (this.tableData.goods.length < 11) {
                this.ShengLength = 11 - this.tableData.goods.length
                this.tableData.allNum = 0
                this.goodsList = this.tableData.goods
                this.tableData.goods.forEach(item => {
                    this.allNum1 += +item.goods_num
                })
            } else if (this.tableData.goods.length >= 11 && this.tableData.goods.length < 23) {
                this.isShow = true
                for (var i = 0; i <= 11; i++) {
                    console.log(this.tableData.goods[i].unit);
                    this.goodsList.push({unit: this.tableData.goods[i].unit, goods_num: this.tableData.goods[i].goods_num, goods_name: this.tableData.goods[i].goods_name, model: this.tableData.goods[i].model})
                }
                this.goodsList.forEach(item => {
                    this.allNum1 += Number(item.goods_num)
                })
                for (var j = 11; j < this.tableData.goods.length; j++) {
                    this.goodsList1.push({unit: this.tableData.goods[j].unit, goods_num: this.tableData.goods[j].goods_num, goods_name: this.tableData.goods[j].goods_name, model: this.tableData.goods[j].model})
                }
                console.log(this.goodsList1);
                this.goodsList1.forEach(item => {
                    this.allNum2 += +item.goods_num
                })
            } else if (this.tableData.goods.length >= 23 && this.tableData.goods.length < 35) {
                this.isShow = true
                this.isShow2 = true
                for (var i = 0; i <= 10; i++) {
                    console.log(this.tableData.goods[i].unit);
                    this.goodsList.push({unit: this.tableData.goods[i].unit, goods_num: this.tableData.goods[i].goods_num, goods_name: this.tableData.goods[i].goods_name, model: this.tableData.goods[i].model})
                }
                this.goodsList.forEach(item => {
                    this.allNum1 += Number(item.goods_num)
                })
                for (var j = 11; j < 22; j++) {
                    this.goodsList1.push({unit: this.tableData.goods[j].unit, goods_num: this.tableData.goods[j].goods_num, goods_name: this.tableData.goods[j].goods_name, model: this.tableData.goods[j].model})
                }
                this.goodsList1.forEach(item => {
                    this.allNum2 += +item.goods_num
                })
                for (var k = 22; k < this.tableData.goods.length; k++) {
                    this.goodsList2.push({unit: this.tableData.goods[k].unit, goods_num: this.tableData.goods[k].goods_num, goods_name: this.tableData.goods[k].goods_name, model: this.tableData.goods[k].model})
                }
                this.goodsList2.forEach(item => {
                    this.allNum3 += +item.goods_num
                })
            }
        },
        mounted() {
            window.print()
        }
    }
</script>
<style lang="less" scoped>
    .ck-dayin{
        font-size: 10px;
        width: 100%;
        .title-left{
            width: 45%;
            text-align: center;
            line-height: 0px;
            display: inline-block;
            font-size: 21px;
        }
        .title-right{
            width: 54%;
            display: inline-block;
            text-align: center;
            img{
                display: inline-block;
                margin-top: 10px;
                margin-right: 40px;
            }
        }
        .center{
            margin-top: -15px;
        }
        .center-left{
            width: 40%;
            display: inline-block;
            box-sizing: border-box;
            padding-left: 15px;
        }
        .center-right{
            width: 55%;
            display: inline-block;
            box-sizing: border-box;
        }
        .fs25{
            font-size: 25px;
            font-weight: bold;
        }
        .fs18{
            /*font-size: 16px;*/
            /*font-weight: bold;*/
        }
        .table{
            display: inline-block;
            width: 100%;
            table,table tr th, table tr td { border:1px solid #000000; }
            table{
                text-align: center; border-collapse: collapse;
                input{
                    border: 0px;
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/router/CangkuDayin.vue